import { VIDEO } from "@/lib/video";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { PlayCircle } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export default function WatchVideoButton({ size = "lg", variant = "outline", className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button size={size} variant={variant} className={className} onClick={() => { setOpen(true); trackEvent("walkthrough_open"); }} data-testid="hero-watch-video">
        <PlayCircle className="w-4 h-4 mr-1.5" /> Watch the video
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-[420px] p-0 bg-black border-0 overflow-hidden [&>button]:text-white [&>button]:bg-black/50 [&>button]:rounded-full [&>button]:p-1.5" data-testid="video-modal">
          <DialogTitle className="sr-only">Futuregen Innovations walk-through video</DialogTitle>
          {open && (
            <video controls autoPlay playsInline poster={VIDEO.poster} className="w-full aspect-[9/16] max-h-[85vh]" data-testid="video-modal-player"
              onPlay={() => trackEvent("walkthrough_play")}>
              <source src={VIDEO.mp4} type="video/mp4" />
            </video>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
